import { useCallback, useEffect, useState } from 'react';

const VOLUME_STEP = 0.1;
const SoundVolumeControls = ({ audio }: any) => {
  const [volume, setVolume] = useState(1);

  useEffect(() => {
    if (!audio) {
      return;
    }

    setVolume(audio.volume);
  }, [audio]);

  const decrease = useCallback(() => {
    if (volume - VOLUME_STEP < 0) {
      return;
    }

    setVolume((prev) => Number((prev - VOLUME_STEP).toFixed(1)));
  }, [volume]);

  const increase = useCallback(() => {
    if (volume + VOLUME_STEP > 1) {
      return;
    }

    setVolume((prev) => Number((prev + VOLUME_STEP).toFixed(1)));
  }, [volume]);

  useEffect(() => {
    if (!audio) {
      return;
    }

    audio.volume = volume;
  }, [audio, volume]);

  const handleVolume = useCallback(
    (data) => {
      setVolume(parseFloat(data.target.value));
    },
    [setVolume],
  );

  return (
    <div className="sound-volume">
      <div className="sound-volume-range">
        <i className="fas fa-plus-circle" onClick={increase} />
        <input type="range" step={VOLUME_STEP} min="0" max="1" value={volume} onChange={handleVolume} />
        <i className="fas fa-minus-circle" onClick={decrease} />
      </div>
      <div className="sound-controls">
        <i className="fas fa-volume-up" />
      </div>
    </div>
  );
};

export default SoundVolumeControls;
